export enum ContactType {
    ServiceProvider = 'Service Provider',
    Business = 'Business',
    Individual = 'Individual',
    Supplier = 'Supplier',
    Team = 'Team',
    Employee = 'Employee',
    Subcontractor = 'Subcontractor',
    LoginContact = 'Login Contact',
    BasicContact = 'Basic Contact',
    SystemAdministrator = 'System Administrator',
    System = 'System',
    Contact = 'Contact',
    WorkBuddyCompany = 'WorkBuddyCompany',
    Equipment = 'Equipment',
    Run = 'Run',
    External = 'External',
    Site = 'Site',
    Adhoc = 'Adhoc',
    Placeholder = "Placeholder",
}
